/* import __COLOCATED_TEMPLATE__ from './location-selector-field.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { subunitsLabel } from '@dashboard/junk-drawer/utils/subunits';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { itemSubunitsServiceActiveSubunits } from '@square/dashboard-utilities/utils/item-subunits';
const LOCATION_OPTION_GLOBALLY_ENABLED_VALUE = 'globally_enabled';
let LocationSelectorField = (_class = class LocationSelectorField extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "locationSelector", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "isSelectingLocations", _descriptor3, this);
    // This value is passed in to a market-select component which is readonly
    // and is only used to display the selected value of the location.
    _defineProperty(this, "dummyValueForDisplay", 'selected-value-for-display');
  }
  get locationsLabel() {
    const selectedLocationsNicknames = this.args.selectedLocations.map(({
      nickname
    }) => nickname);
    return subunitsLabel(selectedLocationsNicknames, this.activeLocations.length);
  }
  get activeLocations() {
    return itemSubunitsServiceActiveSubunits();
  }
  get locationOptions() {
    if (!this.isSelectingLocations) {
      return [];
    }
    const selectedLocationTokens = new Set(this.args.selectedLocations.map(({
      token
    }) => token));
    const options = this.activeLocations.map(location => ({
      value: location.token,
      label: location.nickname,
      checked: selectedLocationTokens.has(location.token)
    }));
    const globallyEnabledOption = {
      value: LOCATION_OPTION_GLOBALLY_ENABLED_VALUE,
      label: this.intl.t('sharedUi.locationsSelectorModal.globallyEnabledLabel'),
      checked: this.args.globallyEnabled
    };
    options.push(globallyEnabledOption);
    return options;
  }
  get modalOptions() {
    return {
      title: this.intl.t('sharedUi.locationsSelectorModal.title'),
      primaryButtonLabel: this.intl.t('sharedUi.locationsSelectorModal.primaryButtonLabel'),
      selectAllLabel: this.intl.t('sharedUi.locationsSelectorModal.selectAllLabel'),
      searchPlaceholder: this.intl.t('sharedUi.locations'),
      enableSearch: true,
      enableSelectAll: true,
      options: this.locationOptions,
      ...this.args.modalOptions
    };
  }
  openModal() {
    this.isSelectingLocations = true;
  }
  closeModal(event) {
    this.isSelectingLocations = false;
    if (!Array.isArray(event)) {
      return;
    }
    const locationChangeEvent = event.reduce((changeEvent, currentValue) => {
      const value = `${currentValue.value}`;
      if (value === LOCATION_OPTION_GLOBALLY_ENABLED_VALUE) {
        return {
          ...changeEvent,
          globallyEnabled: currentValue.checked
        };
      } else if (currentValue.checked) {
        changeEvent.selectedLocationTokens.add(value);
      } else {
        changeEvent.deselectedLocationTokens.add(value);
      }
      return changeEvent;
    }, {
      selectedLocationTokens: new Set(),
      deselectedLocationTokens: new Set()
    });
    if (locationChangeEvent.globallyEnabled) {
      locationChangeEvent.selectedLocationTokens.clear();
    }
    this.args.onChange(locationChangeEvent);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "locationSelector", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isSelectingLocations", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "openModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype)), _class);
export { LocationSelectorField as default };